import { useState, useSyncExternalStore } from 'react';
import { Download, Share, SquarePlus, X } from 'lucide-react';
import { canPromptInstall, dismissInstall, installDismissedRecently, isIosSafari, onInstallAvailability, promptInstall } from '@/lib/install';
import { useStandalone } from '@/lib/app-mode';

const MOBILE = '(max-width: 900px)';
const subscribeMobile = (cb: () => void) => {
  if (typeof window.matchMedia !== 'function') return () => {};
  const mq = window.matchMedia(MOBILE);
  mq.addEventListener('change', cb);
  return () => mq.removeEventListener('change', cb);
};
const readMobile = () => typeof window.matchMedia === 'function' && window.matchMedia(MOBILE).matches;

/**
 * بانرُ التثبيت على الجوال: سطرٌ فوق شريط التبويب يقول «ثبّت رفرفة» — بزرٍّ حقيقي على أندرويد،
 * وبخطوتين مكتوبتين على آيفون (سفاري لا يسمح بزرّ). يُغلق فلا يعود ثلاثين يوماً، ولا يظهر
 * لمن ثبّت التطبيق أصلاً ولا على الحاسوب.
 */
export function InstallPrompt() {
  const standalone = useStandalone();
  const mobile = useSyncExternalStore(subscribeMobile, readMobile, () => false);
  const available = useSyncExternalStore(onInstallAvailability, canPromptInstall, () => false);
  const [hidden, setHidden] = useState(installDismissedRecently);
  const ios = isIosSafari();

  if (standalone || !mobile || hidden || (!available && !ios)) return null;

  const close = () => { dismissInstall(); setHidden(true); };

  return (
    <aside className="install-bar" role="complementary" aria-label="تثبيت التطبيق">
      <img src="/brand/icon-192.png" alt="" width={40} height={40} className="install-bar__icon" />
      <div className="install-bar__text">
        <b>ثبّت رفرفة على جوالك</b>
        {ios
          ? <span className="caption">اضغط <Share size={13} aria-label="مشاركة" /> ثم «إضافة إلى الشاشة الرئيسية» <SquarePlus size={13} aria-hidden /></span>
          : <span className="caption">يفتح كتطبيق من الشاشة الرئيسية — أسرع وبلا شريط المتصفّح</span>}
      </div>
      {!ios && (
        <button type="button" className="btn btn--primary btn--sm" onClick={() => { void promptInstall().then((ok) => { if (ok) setHidden(true); }); }}>
          <Download size={15} aria-hidden /> تثبيت
        </button>
      )}
      <button type="button" className="icon-btn" onClick={close} aria-label="إغلاق"><X size={16} /></button>
    </aside>
  );
}
